/**
 * 
 * @param {int} idDossier 
 * @returns {string} GraphQL Query
 */
export function getTimelineStatusQuery(idDossier) {
    return `TimelineStatusQuery(idDossier: ${idDossier})`;
}
